import { useNavigate } from "react-router-dom"

import { Button, Dropdown } from "@/atoms"
import { NAMES_ROUTES, VALUES_PARAMS } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { FileProtectOutlined } from "@/icons"
import { Protected } from "@/molecules/Protected"
import * as helpers from "@/pages/GovernancePage/helpers/policy"

import type { Permission } from "@/domain/user"
import type { PoliciesPageProps } from "@/pages/GovernancePage/components/pages/PoliciesPage"

export const CreateButtonPolicies = (props: PoliciesPageProps) => {
  const { type } = props
  const { ROOT } = NAMES_ROUTES.GOVERNANCE
  const permission: Permission = helpers.getPermission(type)
  const { t } = useTranslation()
  const policy = t("general.policy", { count: 1 })
  const navigate = useNavigate()
  const getItem = (key: string) => ({
    key,
    label: (
      <div
        data-testid={key}
        className="capitalize-text-ks"
        onClick={() =>
          navigate(`/${ROOT}/${type}/${key}/${VALUES_PARAMS.NEW_ENTITY}`)
        }
      >
        {`${t(`governance.policies.${key}`)} ${policy}`}
      </div>
    )
  })

  return (
    <Protected shouldDisable permission={permission}>
      <Dropdown
        menu={{
          items: [
            getItem(helpers.PROTECT_SUB_TYPE_POLICY),
            getItem(helpers.SUPPRESS_SUB_TYPE_POLICY)
          ]
        }}
        trigger={["hover"]}
      >
        <Button
          id="create-policy-button"
          icon={<FileProtectOutlined />}
          type="primary"
        >
          {`${t("general.create")} ${policy}`}
        </Button>
      </Dropdown>
    </Protected>
  )
}
